<template funtional>
  <div class="mb-2 mt-0 pt-1">
    <div class="flex items-center justify-center text-xl text-dark select-none font-semibold">
      <slot></slot>

      <p v-if="overdue || hideAdd" :class="{'text-danger': overdue}">

        {{title}} <span v-if="showCountOnly">
          ({{count}}) </span><span v-if="showCountAndDone">
         (<span>{{countDone}}</span>/<span>{{count}}</span>)</span>

      </p>
      <p v-else :class="actionElementCss" @click.stop="addCallback">
          {{title}}<span v-if="showCountOnly"> ({{count}})</span><span v-if="showCountAndDone">
         (<span>{{countDone}}</span>/<span>{{count}}</span>)</span>
        <span v-if="!hideAdd" class="text-xl font-bold"> +</span>
      </p>
    </div>
  </div>
</template>
<script>
export default {
  props: [
    'title',
    'count',
    'hideAdd',
    'countDone',
  ],
  computed: {
    overdue () {
      return this.title === 'overdue'
    },
    showCountOnly () {
      return this.count > 0 && (!this.countDone || this.countDone === 0)
    },
    showCountAndDone () {
      return this.count > 0 && this.countDone > 0
    },
  },
  methods: {
    addCallback () {
      this.$emit('addCallback')
    }
  }
}

</script>
